/* Hoisted from snippets/sk-qty-pill-init.liquid (SK perf 2026-09-18): this script used to be inlined once PER PRODUCT CARD
   (30 copies per collection page, ~6.5 KB each: quantity pill controller). It is now loaded once from layout/theme.liquid with defer.
   All init paths (DOMContentLoaded, shopify:section:load, body MutationObserver) are unchanged. */
if (!window.__skQtyPillInit) {
  window.__skQtyPillInit = true;
  (function () {
    var MINUS_SVG = '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"/></svg>';
    var TRASH_SVG = '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14H6L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/><path d="M9 6V4h6v2"/></svg>';

    function updateLeftBtn(pill, qty) {
      var btn = pill.querySelector('.sk-qty-pill__btn--left');
      if (!btn) return;
      btn.innerHTML = qty > 1 ? MINUS_SVG : TRASH_SVG;
      btn.setAttribute('aria-label', qty > 1 ? 'Decrease quantity' : 'Remove item');
    }

    function showPillForVariant(variantId) {
      var pill = document.querySelector('.sk-qty-pill[data-variant-id="' + variantId + '"]');
      if (!pill) return;
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var item = cart.items.find(function (i) { return String(i.variant_id) === String(variantId); });
          if (!item || item.quantity < 1) return;
          pill.querySelector('.sk-qty-pill__count').textContent = item.quantity;
          pill.dataset.lineKey = item.key;
          updateLeftBtn(pill, item.quantity);
          pill.dataset.visible = 'true';
          pill.removeAttribute('aria-hidden');
          var comp = pill.closest('quick-add-component');
          if (comp) comp.classList.add('sk-pill-active');
        });
    }

    function hidePill(pill) {
      // Step 1: trigger CSS width collapse while keeping pill visible
      delete pill.dataset.visible;      // width → button-size-md (transitions), opacity → 0 (base)
      pill.dataset.collapsing = 'true'; // CSS overrides opacity back to 1 during collapse

      // Step 2: after width transition, fade out and restore the add-to-cart button
      pill.addEventListener('transitionend', function onCollapsed(e) {
        if (e.propertyName !== 'width') return;
        delete pill.dataset.collapsing; // triggers opacity 1 → 0 fade (0.2s)
        pill.setAttribute('aria-hidden', 'true');
        var component = pill.closest('quick-add-component');
        if (component) {
          component.classList.remove('sk-pill-active');
          component.removeAttribute('stay-visible');
        }
      }, { once: true });
    }

    function changeQty(pill, delta) {
      var variantId = pill.dataset.variantId;
      var countEl = pill.querySelector('.sk-qty-pill__count');
      var newQty = Math.max(0, parseInt(countEl.textContent, 10) + delta);
      var body = { quantity: newQty };
      body.id = pill.dataset.lineKey ? pill.dataset.lineKey : parseInt(variantId, 10);
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var item = cart.items.find(function (i) { return String(i.variant_id) === String(variantId); });
          if (!item || item.quantity === 0) {
            hidePill(pill);
          } else {
            countEl.textContent = item.quantity;
            pill.dataset.lineKey = item.key;
            updateLeftBtn(pill, item.quantity);
          }
          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: { resource: cart, data: { source: 'sk-qty-pill', itemCount: cart.item_count } }
          }));
        });
    }

    document.addEventListener('cart:update', function (e) {
      var detail = e.detail || {};
      if (!detail.data || detail.data.didError) return;
      if (detail.data.source !== 'product-form-component') return;
      var variantId = detail.sourceId;
      if (variantId) showPillForVariant(variantId);
    });

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.sk-qty-pill__btn');
      if (!btn) return;
      var pill = btn.closest('.sk-qty-pill');
      if (!pill) return;
      e.stopPropagation();
      changeQty(pill, btn.classList.contains('sk-qty-pill__btn--right') ? 1 : -1);
    });

    function activatePillsFromCart(pills, cart) {
      pills.forEach(function (pill) {
        if (pill.dataset.skInit) return; // already initialized
        pill.dataset.skInit = '1';
        var item = cart.items.find(function (i) { return String(i.variant_id) === String(pill.dataset.variantId); });
        if (!item || item.quantity < 1) return;
        pill.querySelector('.sk-qty-pill__count').textContent = item.quantity;
        pill.dataset.lineKey = item.key;
        updateLeftBtn(pill, item.quantity);
        pill.dataset.visible = 'true';
        pill.removeAttribute('aria-hidden');
        var comp = pill.closest('quick-add-component');
        if (comp) comp.classList.add('sk-pill-active');
      });
    }

    function initPills(pills) {
      if (!pills.length) return;
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) { activatePillsFromCart(pills, cart); });
    }

    // MutationObserver: catch pills added after page load (e.g. product-recommendations AJAX)
    var pillObserver = new MutationObserver(function (mutations) {
      var newPills = [];
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches('.sk-qty-pill')) newPills.push(node);
          if (node.querySelectorAll) {
            node.querySelectorAll('.sk-qty-pill').forEach(function (p) { newPills.push(p); });
          }
        });
      });
      if (newPills.length) initPills(newPills);
    });

    function initFromCart() {
      pillObserver.observe(document.body, { childList: true, subtree: true });
      initPills(Array.from(document.querySelectorAll('.sk-qty-pill')));
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initFromCart);
    } else {
      initFromCart();
    }
  }());
}
